import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { FaUsers, FaMapMarkerAlt, FaCalendarCheck } from 'react-icons/fa';
import { MdSportsSoccer } from 'react-icons/md';
import './Stats.css';

const stats = {
  ar: {
    title: 'أرقامنا تتحدث',
    subtitle: 'نفخر بثقة مجتمعنا الرياضي المتنامي',
    items: [
      { icon: <FaUsers />,         value: 600,  label: 'مستخدم',  suffix: '+', color: '#fff' },
      { icon: <MdSportsSoccer />,  value: 40,   label: 'ملعب',    suffix: '+', color: '#fff' },
      { icon: <FaMapMarkerAlt />,  value: 7,    label: 'مدينة',   suffix: '+', color: '#fff' },
      { icon: <FaCalendarCheck />, value: 1000, label: 'حجز',     suffix: '+', color: '#fff' },
    ]
  },
  en: {
    title: 'Our Numbers Speak',
    subtitle: 'Proud of our growing sports community',
    items: [
      { icon: <FaUsers />,         value: 600,  label: 'Users',    suffix: '+' },
      { icon: <MdSportsSoccer />,  value: 40,   label: 'Stadiums', suffix: '+' },
      { icon: <FaMapMarkerAlt />,  value: 7,    label: 'Cities',   suffix: '+' },
      { icon: <FaCalendarCheck />, value: 1000, label: 'Bookings', suffix: '+' },
    ]
  },
};

function Stats({ language }) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <section id="stats" className="stats-section" ref={ref}>

      {/* Floating orbs */}
      <div className="stats-orb stats-orb-1" />
      <div className="stats-orb stats-orb-2" />
      <div className="stats-orb stats-orb-3" />

      <div className="container">
        <div className="stats-header" data-aos="fade-up">
          <h2>{stats[language].title}</h2>
          <p>{stats[language].subtitle}</p>
        </div>

        <div className="stats-grid">
          {stats[language].items.map((s, i) => (
            <div className="stat-card" key={i} data-aos="fade-up" data-aos-delay={i * 120}>
              <div className="stat-card-glow" />
              <div className="stat-icon-wrap">
                <div className="stat-icon">{s.icon}</div>
              </div>
              <div className="stat-value">
                {inView
                  ? <CountUp end={s.value} duration={2.2} separator="," useEasing />
                  : 0}
                <span className="stat-suffix">{s.suffix}</span>
              </div>
              <div className="stat-label">{s.label}</div>
              <div className="stat-line" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Stats;
